// Eltafouk: shared identifiers for the Comments ("التعليقات") section.
//
// The Comments section is not a separate screen — it reuses the conversation
// dashboard's component tree (ChatList / ChatListHeader / ConversationHeader …).
// So the shared chrome needs ONE reliable way to answer "are we currently
// viewing comments, not DMs (المحادثات)?". These identifiers are that single
// source of truth: imported both by the sidebar (which builds the التعليقات
// section) and by ConversationView (which derives the `isCommentSection` flag),
// so the two can never drift.

// Account-wide route signal: the "جميع قنوات التعليقات" view is reached via the
// `conversation_all_comments` route, which passes this as `conversationType`.
export const COMMENT_CONVERSATION_TYPE = 'comments';

// List heading for the Comments section — the parallel of the DMs heading
// "المحادثات". Kept here (not in i18n) to match how the rest of the comment
// section already uses inline Arabic labels (see Sidebar.vue) and so the title
// the owner sees is Arabic immediately, without waiting on a translation key.
export const COMMENTS_SECTION_TITLE = 'التعليقات';

// Account-wide label backing the "كومنتات عاجلة خلاف (تم)" (needs-reply) view.
export const COMMENT_NEEDS_REPLY_LABEL = 'محتاج-رد';

// Legacy per-user CustomFilter folder IDs. These folders are now orphaned — the
// section routes via account-wide routes/labels instead — but their IDs are
// still used to keep the orphaned filters out of the DMs (المحادثات) folder list.
export const ALL_COMMENTS_FOLDER_ID = 2;
export const COMMENT_UNASSIGNED_FOLDER_ID = 3;
export const COMMENT_UNREPLIED_FOLDER_ID = 4;
export const COMMENT_NEEDS_REPLY_FOLDER_ID = 5;

export const COMMENT_FOLDER_IDS = [
  ALL_COMMENTS_FOLDER_ID,
  COMMENT_UNASSIGNED_FOLDER_ID,
  COMMENT_UNREPLIED_FOLDER_ID,
  COMMENT_NEEDS_REPLY_FOLDER_ID,
];

// Comment-section copy: the parallels of the DM list strings (CHAT_LIST.EOF /
// CHAT_LIST.LIST.404 / CONVERSATION.SELECT_A_CONVERSATION), which all say
// "محادثة/محادثات". Kept inline (not in i18n) to match COMMENTS_SECTION_TITLE
// above so the التعليقات section reads correctly in Arabic immediately.
export const COMMENTS_EOF_MESSAGE = 'تم تحميل كافة التعليقات 🎉';
export const COMMENTS_EMPTY_LIST_MESSAGE = 'لا توجد تعليقات في هذه المجموعة.';
export const COMMENTS_SELECT_MESSAGE = 'الرجاء اختيار تعليق من القائمة';
